const en = {
    "401": {
        "oops": "Oops!",
        "noAuth": "You do not have permission to access this page",
        "goback": "Back to previous",
        "gohome": "Home"
    },
    "404": {
        "notFound": "Page not found!"
    },
    "version": {
        "to_old": "Previous version",
        "to_new": "New version",
        "default_node": "Default node",
        "default_theme": "Default Theme",
        "custom_theme": "Custom Theme"
    },
    "intro": {
        "sys_msg": "System message",
        "gaa_msg": "Alarm reminder",
        "new_guide": "Novice guidance",
        "slider_quite": "Exit boot",
        "slider_pre": "Previous",
        "slider_next": "Next",
        "slider_enter": "Enter the new version",
        "step_project_1": "Management device of new system",
        "step_project_2": "Newly added",
        "step_project_3": "Project",
        "step_project_4": "Function, device management by item. Users can edit the project",
        "step_project_5": "new, edit, delete",
        "step_mode_1": "Choose your favorite device list style",
        "step_mode_2": "The device list can be accessed through",
        "step_mode_3": "List or card",
        "step_mode_4": "You can choose the presentation method according to your situation.",
        "step_device_1": "Quickly find devices of interest",
        "step_device_2": "Newly added",
        "step_device_3": "Focus on device",
        "step_device_4": "Function,",
        "step_device_5": "Mouse over",
        "step_device_6": "While on the device, you can click follow,",
        "step_device_7": "After attention",
        "step_device_8": "Device can be used in this project as",
        "step_device_9": "Topping",
        "step_device_10": "Which is convenient for you to find the device you care about.",
        "step_operate_1": "Clearer device information layout",
        "step_operate_2": "After selecting the device you want to know, you can quickly browse the energy flow diagram, device information, data chart, parameter analysis, data details and alarm information of the device."
    },
    "plantCode": {
        "codeApplication": "Experience code application",
        "haveDevice": "If you have device,Sign in to use",
        "goRegister": "Go to sign up",
        "useDemo": "No invitation code yet？The invitation code is for demonstration only",
        "applyNow": "Apply now",
        "code_is_required": "The experience code is required",
        "pleaseCode": "Please input the invitation code",
        "pleaseName": "Please input your name",
        "PleaseCompanyName": "Please input company name",
        "PleaseCompanyAddress": "Please input company address",
        "PleaseNumber": "Please input your phone",
        "PleaseEmail": "Please input your email",
        "PleaseApplication": "Please describe the reason for your application",
        "reasonNotEmpty": "The reason for application cannot be empty",
        "successfulApplication": "Successful application,Please pay attention to your phone or email information，We will get back to you as soon as possible"
    },
    "retrieveUser": {
        "forgetUser": "Forgot account",
        "illustrate": "If you forget your account, you can obtain account information prompts by entering the PN number of any device under your account, helping you recall your account!",
        "pn": "Please enter the PN of any device under your account",
        "comfig": "Confirm",
        "Return_to_login": "Return to sign in",
        "accountInfo": "Account info",
        "user": "Your username is",
        "phone": "The phone bound to your account is",
        "email": "The email associated with your account is",
        "pleasePn": "Please enter the device PN",
        "pnError": "The PN you entered is incorrect",
        "pnErrorMsg": "Datalogger not found"
    },
    "login": {
        "login": "Sign in",
        "loginSuc": "Sign in success",
        "no_account_yet": "Don't have an account?",
        "remember_pwd": "Remember",
        "no_invitation": "No Experience code yet? Please contact us!",
        "linkman": "Eybond",
        "signup": "Sign up",
        "usr": "Username",
        "pwd": "Password",
        "sample_station": "Demo",
        "invitation": "Experience Code",
        "invitationLogin": "Experience code sign in",
        "forgotPwd": "Forgot pwd?",
        "forgotUser": "Forgot account",
        "usrformat": "Account format is wrong(2<=Account digits<=32)",
        "pwdformat": "Password format is wrong(6<=Password digits<=32)",
        "YHLogin": "Sign in",
        "YZcode": "Please input the verification code",
        "code": "Slide the lower slider to complete the puzzle",
        "Swipe_right": "Swipe right",
        "scan_login": "Scan code sign in",
        "open": "open",
        "Scancode_login": "Scan code sign in",
        "scanning": "Scan",
        "success": "Success",
        "Pleaseconfirm_login": "Please confirm sign in",
        "SmartESS": "SmartESS",
        "pv123": "PV123 ESS",
        "X_Tech": "X-Tech",
        "app_download": "APP download",
        "scan_download": "APP download",
        "YZcode_format": "verification code format is wrong. Please enter a number",
        "no_validitycode": "The invitation code is not within its validity period",
		"auto_login": "Auto login",
    },
    "signup": {
        "login": "Sign in",
        "code": "6-digit verification code",
        "pwd": "6-32 character(number, letter,Underline),Case sensitive",
        "confirm_password": "Confirm Password",
        "phone": "Phone",
        "phone_form": "within 32 character, fill accurately to find password.",
        "pn": "14 or 18-character(only numbers and letters)",
        "usr": "2-32 character(Chinese,letter,number,Underline)",
        "email": "Email",
        "email_form": "within 64 character, fill accurately to find password.",
        "existing_account": "Already have an account?",
        "Register_account": "Sign up an account",
        "signup": "Sign Up",
        "emailSignup": "Email sign up",
        "phoneSignup": "Phone sign up",
        "registered": "Sign up",
        "success": "Successful sign up!",
        "mobileformat": "Incorrect format of phone  (6-32 digits)",
        "mobileformat1": "Please enter the correct phone",
        "emailformat": "Please enter the correct mailbox",
        "usrformat": "Account error,2-32 digits(only Chinese, letters, numbers underline)",
        "pwdformat": "Pwd format error,6~32 digits (only numbers, letters, Underline)",
        "pnformat": "PN format error, 14 or 18 digits (only numbers and letters)",
        "qiang": "Strong",
        "zhong": "Medium",
        "di": "Weak",
        "qiangdu": "Password Strength:",
        "Byte_1": "Already input",
        "Byte_2": "Character",
        "usr_pl": "Username",
        "pwd_pl": "Password",
        "confirm_pl": "Please input your password again",
        "confirm_Pwdpl": "Confirm password",
        "email_pl": "Email",
        "mobile_pl": "Phone",
        "code_pl": "Verification Code",
        "PN_pl": "PN",
        "too_simple": "Password is too simple, please re-enter",
        "country_pl": "Country or Region",
    },
    "createPlant": {
        "imageLimit": "Images only 'jpg', 'png', and can't exceed 8M",
        "fileExceed": "File size exceeded",
        "uploadSuccess": "Upload success",
        "basic_settings": "Basic setting",
        "Standard_setting": "Standard setting",
        "System_settings": "System setting",
        "Solar_settings": "Solar energy setting",
        "Grid_settings": "Grid setting",
        "Battery_settings": "Battery setting",
        "Battery_settingsTT": "Battery General Settings",
        "Battery_settings1": "Battery Pack 1",
		"Battery_settings2": "Battery Pack 2",
        "Work_settings2": "Set system working status",
        "Machine_settings2": "Enable machine standby function",
        "Clear_settings2": "Clear fault",
        "Control_settings": "Accumulator setting",
        "Load_setting": "Load setting",
        "other_settings": "Other setting",
        "Basic_setting": "Basic setting",
        "Advanced_setting": "Advanced setting",
        "select_all": "Select All",
        "pv": "PV",
		"gd": "Grid",
		"bt": "Battery",
		"bc": "Load",
		"sy": "System",
		"eg": "Generator",
		"hl": "HouseholdLoad"
    },
    "Upload": {
        "Upload": "Upload"
    },
    "menu": {
        "home": "Home",
        "datalogger": "Datalogger",
        "account": "Account",
        "device": "Device",
        "overview": "Overview",
        "alarm": "Alarm",
        "setting": "Setting",
        "personal": "Personal info",
        "basic": "Basic info",
        "password": "Edit Password",
        "alarmSetting": "Alarm setting",
        "email": "Email setting",
        "mobile": "Phone setting",
        "recharge": "Recharge setting",
        "pay": "Traffic Recharge",
        "record": "Recharge Record",
        "rate": "Rate setting",
        "customize": "Custom setting",
        "firmware": "Default Firmware",
        "firmwarenew": "Firmware",
        "adaptiveFirmware": "Adaptive Firmware",
        "intelligenceUpgrade": "Smart Upgrade",
        "intelligenceUpgradeTitle": "No upgrade package available, please contact the manufacturer",
        "intelligenceUpgradeTitle1": "Please confirm if the device should undergo smart upgrade?",
        "intelligenceUpgradeTitle2": "No matching upgrade package found",
        "Total_user": "Total user:",
        "myDevice": "My device",
        "strategy": "Strategy setting",
        "cloudsUpgrade": "Cloud Upgrade",
        "functionalApplication": "Functional Application",
        "browseAccount": "Sub account management",
        "log": "Datalogger Log",
        "actionLog": "Action Log",
        "Manufacturer": "Manufacturer",
        "datalogger_list": "Datalogger List",
        "manufacturer_account": "Manufacturer Account",
        "manufacturer_code": "Manufacturer Code",
        "protocol_binding": "Protocol Binding",
        "type_code": "Type Code",
        "protocol_change": "Protocol Change",
        "AIP_Interface": "API interface",
        "protocol_operation": "Protocol operation",
        "recharge_management": "Recharge management",
        "device_management": "Device management",
        "KEY_List": "KEY List",
        "Protocol_instruction": "Protocol management",
        "Raw_data": "Raw data parsing",
        "Recharge_remedy": "Recharge remedy",
        "device_function": "Device management function",
        "Password_maintenance": "Control item password maintenance",
    },
    "header": {
        "plant_owner": "Plant Owner",
        "personal_infor": "Personal info",
        "change_password": "Change Password",
        "bind_mobile": "Bind phone",
        "bind_email": "Bind Email",
        "language": "Language",
        "log_out": "Sign out",
        "skin": "Switch Skin",
        "shopping_mall": "Shop",
        "operating_manual": "Manual",
        "pleaseSelect": "Select",
        "pleaseSelect1": "Select time",
        "pnAndAlias": "PN / Name",
        "pnAndSN": "PN / SN"
    },
    "role": {
        "plantOwnerNew": "Ordinary User",
        "plantOwner": "Power Station Owner",
        "manufacturer": "Manufacturers Account",
        "distributor": "Distributor",
        "group": "Group Account",
        "viewer": "Power Station Viewer",
        "all": "All"
    },
    "statistic": {
        "All": "All",
        "regiontotal": "Total area",
        "deviceStatus": "Device Status",
        "regionPercent": "Regional Ratio",
        "userActivity": "User Activity Rate",
        "dataUpdateTime": "Data Update Time",
        "normal": "Normal",
        "offline": "Offline",
        "Allstate": "All",
        "warning": "Warning",
        "fault": "Fault",
        "standby": "Standby",
        "totalDevice": "All Device",
        "allDevice": "All Device",
        "totalRegion": "All Region",
        "other": "Other",
        "allAccount": "All User",
        "generalAccount": "Owners Users",
        "adminAccount": "Distributor User",
        "active": "Active",
        "inactive": "Inactive",
        "pv": "Photovoltaic Panel Data",
        "gd": "Grid Data",
        "sy": "Device Data",
        "bt": "Battery Data",
        "bc": "Load Data"
    },
    "account": {
        "title_pwd": "Please enter the correct password",
        "title_pwd1": "Please enter a 6-32 bit password",
        "title_pwd2": "Please enter the new password again",
        "title_mobile": "Please enter an 11 digit phone",
        "title_edit": "Please enter the information that needs to be edited",
        "title_info": "Please enter the correct email",
        "title_info1": "Please enter the correct phone",
        "allAccount": "All users",
        "userAccount": "User",
        "groupAccount": "Group",
        "uselists": "User management list",
        "accountManage": "Account Manage",
        "groupManage": "Group Manage",
        "activeStatus": "Active Status",
        "accountGroup": "User Group",
        "createAccount": "Create",
        "relatedOwner": "Related owner",
        "relatedSuccess": "Association succeeded",
        "adminRelated": "Please select an administrator",
        "role": "User Type",
        "role1": "User Type:",
        "selectUserType": "Please select a user type!",
        "generalAccount": "General Account",
        "manageAccount": "Management Account",
        "accountName": "Username",
        "accountName1": "Username:",
        "accountName2": "enter one username",
        "accountRole": "Role",
        "nickname": "Nickname",
        "nickname1": "Nickname:",
        "password": "Password",
        "password1": "Password:",
        "newPwd": "New Password",
        "newPwd1": "New Password:",
        "confirmpassword": "Confirm Password",
        "confirmpassword1": "Confirm Password:",
        "createTime": "Creation Time",
        "accountStatus": "Account Status",
        "dataloggerNum": "Dataloggers",
        "deviceNum": "Device quantity",
        "projectNum": "Number of project",
        "lastLogin": "Last sign in",
        "editUser": "Edit User",
        "editAccount": "Edit Account",
        "group": "Group",
        "group1": "Group:",
        "groupto": "Group Into",
        "changeGroup": "Change grouping to:",
        "chooseGroup": "Please select a group",
        "changeGroupSuc": "Change grouping successfully!",
        "defaultGroup": "Default Group",
        "enable": "Enable",
        "disable": "Disable",
        "confirmDisable": "Confirm to disable this user?",
        "afterDisable": "After disable, the account will not be able to sign in, and the related content of the account cannot be viewed or edit.",
        "disableSuc": "Disable the account successfully!",
        "confirmEnable": "Confirm to enable this user?",
        "deleteUser": "Delete User",
        "afterEnable": "After enabling, the account can be restored to sign in, view or edit the related content of the account.",
        "confirmDelete": "Confirm to delete?",
        "notRecovered": "It cannot be recovered after deletion...",
        "deleteSuc": "Successfully deleted!",
        "resetPwd": "Reset Password",
        "allTypeUser": "All types of users",
        "powerStationOwner": "Power Station Owner",
        "powerStationViewer": "Power Station Viewer",
        "admin": "Admin",
        "riyueyuan_lineSonAdmin": "Production SubAdmin",
        "riyueyuan_SonAdmin": "SubAdmin",
        "nodata": "No Data",
        "reason": "The reason for not displaying the chart may be:",
        "reason1": "No data for the device",
        "reason2": "The device agreement has no parameter fields of power generation, power consumption, purchased power, sold power, charging capacity and discharge capacity",
        "reason3": "The device protocol has no parameter fields of power generation, load power, battery power and grid power",
        "createSuc": "Create an account successfully!",
        "resetPwdSuc": "Reset password successfully!",
        "allGroup": "All Groupings",
        "unclassified": "Unclassified",
        "cannotRedirect": "This account is not an energy storage account, can not redirect!",
        "newPwdEmpty": "The new password cannot be empty, please fill it out!",
        "accountList": "Account List",
        "mobile": "Phone",
        "mobile1": "Phone:",
        "email": "Email",
        "email1": "Email:",
        "modifiedsuccess": "User info edit successfully!",
        "enablesuccess": "Enabled successfully!",
        "disablesuccess": "Disabled successfully!",
        "groupsuccess": "Increase group successfully!",
        "pwdresetsuccess": "Password reset successfully!",
        "Deletesuccessfully": "Delete account successfully!",
        "plantOwner": "Power Station Owner",
        "distributor": "Distributor",
        "operate": "Operate",
        "Edit": "Edit",
        "Delete": "Delete",
        "binding": "Binding",
        "ascription": "Ascription",
        "ascriptionSuccess": "Belonging successfully",
        "ascription_result": "Attribution result",
        "cancel": "Cancel",
        "finish": "Finish",
        "confirm": "Confirm",
        "submit": "Submit",
        "deletegroupsuccess": "Move out of the group successfully!",
        "deletegroup": "Move out of this group",
        "currentTotal": "Current",
        "projects": "Projects",
        "searchPro": "Search project",
        "devices": "Devices",
        "accounts": "Accounts",
        "placeholder": "Search username / Phone",
        "placeholder1": "Enter One username / Phone",
        "lastLoginTs": "Last sign in time",
        "enterHome": "Go Home",
        "ownedDevices": "Owned Devices",
        "Distribution_collector": "Distribution datalogger",
        "tooltipContent": "The administrator can assign all dataloggers under the order to a subordinate dealer through the order number",
        "Distribution_method": "Distribution method",
        "Batch_allocation": "Batch allocation",
        "Individual_allocation": "Individual allocation",
        "Order_allocation": "Order allocation",
        "PNNum": "PN",
        "order_number": "Order NO",
        "Allocation_result": "Allocation result",
        "Assigned_successfully": "Assigned successfully",
        "order_check": "Check",
        "Confirm_assignment": "Confirm assignment to",
        "IsIt": "is it",
        "limitFormat": "Only files in \"xlsx\" and \"xls\" formats can be uploaded",
        "Ple_orderNum": "Please enter the order no",
        "Ple_orderNum1": "Please enter the correct order no",
        "Ple_orderNum2": "This order has",
        "Ple_orderNum3": "dataloggers, confirm allocation to",
        "err_orderNum": "In the order",
        "err_orderNum1": "Dataloggers have been bound. Please confirm that the dataloggers in the order are not bound",
        "dataogger_swith": "add Datalogger",
        "dataogger_swithTip": "Can this account have the permission to add Datalogger",
        "account_number": "Account",
        "Role_authority": "Permissions",
        "authority_Management": "Permissions Management",
        "Related_roles": "Related roles",
        "Ple_role1": "Please select the associated role",
        "Ple_role2": "Please enter the role name/ID",
        "Add_role": "Add Role",
        "Edit_role": "Edit Role",
        "Role_id": "Role ID",
        "Role_name": "Role Name",
        "Ple_role3": "Please enter the role name",
        "Role_des": "Role Description",
        "Ple_role4": "Please enter role description",
        "module": "Module",
        "First_page": "Page",
        "Secondary_page": "Secondary page",
        "Function_points": "Function",
        "Remove_role": "Delete role",
        "Ple_role5": "Please check the account permissions",
        "No_permission_prompt": "No permission, please contact the higher-level administrator",
        "Ple_role6": "The role name already exists, please re-enter",
        "limit_UserTypeNum": "Exceeding the limit, this account type already exists",
        "limit_UserTypeDataPermission": "Dealer accounts cannot bind roles with selected data permissions.",
        "edit_limit_UserTypeDataPermission": "The role is associated with a dealer account, and data permissions cannot be edited",
        "dataPermission": "Data permission",
        "functionalPermission": "Functional permission"
    },
    "group": {
        "Create_groups": "Create Groups",
        "Edit_groups": "Edit Groups",
        "Groups_list": "Groups List",
        "Group_name": "Group Name",
        "Group_name1": "Group Name:",
        "userCount": "User Count",
        "note": "Note",
        "note1": "Note:",
        "Operate": "Operate",
        "Delete": "Delete",
        "cancel": "Cancel",
        "finish": "Finish",
        "confirm": "Confirm",
        "deletegroup": "Delete Group",
        "deleteConfirm": "Confirm to delete this group?",
        "entername": "Please input a group name",
        "deletesuc": "Delete group successfully",
        "creatsuc": "Create a group successfully",
        "editsuc": "Edit a group successfully"
    },
    "device": {
        "set": "Setting",
		"ownerShip": "Owner Change",
        "oldOwner": "Previous Owner:",
        "nweOwner": "New Owner:",
        "loading": "Loading...",
        "moreLoading": "Scroll to load more",
        "pleaseDate": "Please select a date",
        "noDate": "Cannot select a future date",
        "deviceDebug": "Device commissioning",
        "upgradeType": "Upgrade method:",
        "defaultUpgrade": "Default Upgrade",
        "cloudUpgrade": "Cloud Upgrade",
        "continueUpgrade": "Continue upgrading",
        "continueUpgradeSuccess": "Successfully upgraded and added",
        "step": "Start steps:",
        "firmware_step_message": "Please enter the steps",
        "numberRlues": "Please enter the correct number of steps",
        "firmware_package_message": "Please select firmware",
        "firmware_type_message": "Please select a type",
        "baudrate_message": "Please select Baud",
        "device_continueUpgrade": "Device continues to upgrade",
        "read": "Read",
        "distribute": "Send",
        "optionTitle": "Selected",
        "optionTitle1": "term",
        "optionTitle2": "The selection of device parameters cannot exceed 4",
        "optionTitle4": "The selection of device parameters cannot exceed 12",
        "optionTitle3": "Please do not select options with more than 2 different units",
        "upBatchDeviceTip": "Note: batch upgrade is to upgrade the firmware of the same device for multiple devices. If you don't know the firmware suitable for the device, please choose carefully!",
        "upSuccessDevice": "Successfully upgraded device",
        "upFailDevice": "Failed upgraded device",
        "brandDevice": "Device",
        "brand0": "Other",
        "brand1": "Off-grids",
        "brand2": "Inverter",
        "brand3": "ES integrated",
        "Allthemachines": "All the machines",
        "device": "Device",
        "datalogger": "Datalogger",
        "deviceList": "Device List",
        "dataloggerList": "Datalogger List",
        "followList": "Care about device",
        "proList": "Project List",
        "pro": "Project",
        "deviceName": "Device name",
        "dataview": "Real-time data",
        "dataTips": "The current device is offline and has no real-time data.",
        "overview": "Statistical Overview",
        "chart": "Chart",
        "analysis": "Analysis",
        "clause": "Details",
        "Current_data": "Current Data",
        "chosenParam": "Selected Parameter",
        "optionalParam": "Optional Parameter",
        "reset": "Reset",
        "energyFlow": "Energyflow",
        "device_name": "Device name",
        "device_pn": "PN",
        "device_sn": "SN",
        "device_status": "Device Status",
        "device_upgrade1": "Last upgrade record",
        "device_upgradeFirmware": "Select a firmware package to upgrade the device",
        "device_upgradeTime": "Upgrade time",
        "device_upgradeName": "Upgrade firmware name",
        "device_upgradeStatus": "Upgrade status",
        "device_upgradeProgress": "Upgrade progress",
        "device_type": "Type",
        "device_code": "Protocol",
        "device_code_form": "Protocol:",
        "device_model": "Device model",
        "User_belong": "User",
        "field": "Field control",
        "Datalogger_belong": "Datalogger",
        "detail": "Detail",
        "pageSize": "Page Size",
        "follow": "Follow",
        "unfollow": "Unfollow",
        "report": "Report",
        "timeSlot": "Time Slot",
        "datalogger_pn": "PN",
        "coll_alias": "Datalogger Alias",
        "device_address": "Device address",
        "generation": "PV",
        "grid": "Grid",
        "inverter": "Inverter",
        "battery": "Battery",
        "consumption": "Load",
        "relay": "Relay",
        "alternator": "Generator",
        "familyLoad": "Family load",
        "solar": "Solar",
        "cur_today": "Today",
        "cur_thismonth": "This month",
        "cur_thisyear": "This year",
        "cur_day": "",
        "cur_month": ".",
        "cur_year": ".",
        "day": "Real time power",
        "month": "Current month electricity",
        "year": "Current year electricity",
        "all": "Total electricity",
        "pvPower": "Power Generation",
        "gridPower": "Grid Power",
        "batteryPower": "Battery Power",
        "loadPower": "Load Power",
        "generated": "Energy Generated",
        "charged": "Energy Charged",
        "discharged": "Energy Discharged",
        "sold": "Energy Sold",
        "bought": "Energy Bought",
        "used": "Energy Used",
        "normal": "Normal",
        "offline": "Offline",
        "warning": "Warning",
        "fault": "Fault",
        "standby": "Standby",
        "universal_firmware": "General firmware",
        "communication_firmware": "Communication Firmware",
        "control_firmware1": "Control Firmware 1",
        "control_firmware2": "Control Firmware 2",
        "control_firmware_bms": "BMS Firmware",
        "control_firmware_slavmcu": "Slavmcu Firmware",
        "default": "Default",
        "modifySuc": "Successfully edit",
        "instruction_response": "Sending an instruction, waiting for a response...",
        "debug_suc": "Successful debugging",
        "Debugfail": "Debug failed, device is offline.",
        "Send_suc": "Send command successful",
        "Send_Input": "Please input the operation value to send",
        "Send_fail": "Send command fail",
        "fileExceed": "File size exceeded",
        "uploadSuccess": "Upload success!",
        "error1": "Only files in '.bin' and '.hex' formats can be uploaded!",
        "file_fist": "Please choose the firmware first",
        "updatefail": "Upgrade fail,device is offline.",
        "update_suc": "Successfully update",
        "deleteSuc": "Successfully deleted",
        "Operation": "Operation",
        "edit": "Edit",
        "debug": "Debug",
        "upgrade": "Batch upgrade",
        "upgrade1": "Upgrade",
        "cloudsUpgrade": "Cloud Upgrade",
        "queryUpgrade": "Batch query upgrade progress",
        "control": "Control",
        "delete": "Delete",
        "modify_alias": "Edit Device",
        "serial_number": "SN:",
        "device_alias": "Device name:",
        "cancel": "Cancel",
        "confirm": "Confirm",
        "Device_sn": "Device Serial Number",
        "Device_pn": "PN:",
        "Instruction": "Instruction:",
        "such_as": "Type in your command,like:AA BB CC DD EE FF",
        "return_content": "Return Content:",
        "send": "Send",
        "clear_data": "Clear Data",
        "clear_val": "Clear",
        "copy_val": "Copy",
        "copy_val_yes": "Copy Success",
        "copy_val_no": "Copy Error",
        "Field_Name": "Field Name",
        "Unit": "Unit",
        "current_val": "Current Val",
        "Battery_voltage": "Battery voltage",
        "Magnification": "Magnification",
        "Send_Command": "Send Command",
        "device_upgrade": "Device Firmware Upgrade",
        "device_cloudsUpgrade": "Device Cloud Upgrade",
        "select_firmware": "Firmware:",
        "select_file": "Please Select the firmware file",
        "firmware_type": "Firmware Type:",
        "select_type": "Please Select the firmware type",
        "upgrade_brate": "Baud Rate:",
        "select_brate": "Please Select the baud rate",
        "Upload": "Upload",
        "Upload1": "Upload new firmware",
        "more": "More Actions",
        "one_click_read": "One-Click Read",
        "confirm_deldte": "Confirm to Delete?",
        "deleteDevice": "Delete Device",
        "Today_income": "Daily power generation income",
        "Cumulative_income": "Total revenue from power generation",
        "sellProfit_Today": "Daily electricity sales revenue",
        "sellProfit_Total": "Total revenue from electricity sales",
        "buyProfit_Today": "Current electricity purchase expenses",
        "buyProfit_Total": "Total electricity purchase expenses",
        "noAuth": "No user, no permission to view",
        "statistic": "Statistic",
        "protocolStatistic": "Protocol Statistic",
        "chooseProtocol": "Choose Protocol:",
        "parameter": "Parameter",
        "value": "Value",
        "Upgrading": "Upgrading, please wait",
        "System_Failed": "The system failed to start the device upgrade process due to communication anomalies or other reasons",
        "Device_Offline": "Device or datalogger is offline",
        "In_Upgrading": "Device or datalogger is already in the upgrade",
        "Update_Completed": "Update completed",
        "Voltage": "Voltage",
        "Electric": "Electric",
        "power": "Power",
        "frequency": "Frequency",
        "Input_form": "Input table",
        "add": "Add",
        "Output_table": "Output table",
        "Please_parameter": "Please select a parameter",
        "Successfully_modified": "Successfully edit",
        "edit_control": "Device Permissions",
        "Equipment_agreement": "Device Agreement",
        "Check_all": "Check all",
        "Cancel_all": "Cancel all",
        "administrator_cansee": "The selected permissions are visible to the Subordinate administrator, and the delegate is not visible.",
        "person_cansee": "The selected permissions are visible to the owner, and the delegate is not visible.",
        "noDataPlease": "No data, please choose a new time",
        "admin_authority": "Admin Authority",
        "person_authority": "Person Authority",
        "Sn_deviceName": "SN / Device name / PN / User",
        "deviceInfo": "Device info",
        "alarmInfo": "Alarm info",
        "deviceNo": "You haven't added a device yet",
        "showParam": "Show Param",
        "selecParameters": "Parameter Selected",
        "refresh": "Refresh",
        "obtain": "Obtain",
        "moveResults": "Move Results",
        "moveSuc": "Successfully moved",
        "maxSelect": "Only 7 parameters can be checked at most",
        "minSelect": "At least 1 parameters need to be checked",
        "loadMore": "Load more ...",
        "upDevice": "Upgrade Device",
        "addUpgrade": "Add Upgrade Task",
        "upgradeProgress": "Current upgrade progress",
        "deviceUpgradeProgress": "Device upgrade progress",
        "addUpgradeSuccess": "Add success",
        "domain": "Domain",
        "create_ctrl_title": "Create device control maintenance",
        "edit_ctrl_title": "Edit device control maintenance",
        "delete_domain": "Delete domain",
        "delete_tips": "Are you sure to delete the custom domain device control password?",
        "hostname_required": "Hostname is required",
        "device_rerolling": "Device Rerolling",
        "device_synchronization": "Device Synchronization",
        "update_first_data_time": "Update First Data Time",
        "delete_device_chart_data": "Delete Device Chart Data",
        "delete_device_data": "Delete Device Data",
        "SN_required": "SN is equired",
        // "device_code":"Device code",
        "device_code1": "Device Code",
        "devcode_required": "Device code is required",
        // "device_address":"Device address",
        "devaddr_required": "Device address is required",
        "devaddr_again": "Please enter the device address again",
        "PN": "PN",
        "SN": "SN",
        "SN_again": "Please enter the SN again",
        "search_btn": "Search",
        "tips1": "Tip: When synchronizing from mongodb to mysql, the device's energy output is incorrect. Please roll again and then synchronize (the energy output may not be correct, but may be caused by incorrect data details).",
        "tips2": "Tip: Please enter the device serial number and mailing address again",
        "tips3": "Tip: Once the data details are deleted, they can never be found back, and the data of the corresponding chart can never be calculated again",
        "tips4_1": "Tip: The current device time zone is",
        "tips4_2": "Please note the device time zone, add the corresponding time according to the current time zone, and enter the device serial number and communication address again",
        "delete_tips_1": "Are you sure to delete the data with timestamp:",
        "delete_tips_2": "",
        "sn_is_required": "SN is required",
        "sdate_required": "Start date is required",
        "edate_required": "end date is required",
        "data_tips": "The parameter is not complete",
        "match_tips": "The SN and device address of the device are inconsistent",
                "unbind_tips": "This device is not bound to an owner, please bind the owner first"
    },
    "alarm": {
        "device_Warning": "Device alarm",
        "device_Error": "Device error",
        "device_Fault": "Device failure",
        "Alarm_Event": "Alarm event",
        "Today_Alarm": "Today Alarm",
        "Alarm_Type": "Alarm Type",
        "Device_Type": "Type",
        "Alarm_Status": "Alarm Status",
        "Alarm_List": "Alarm List",
        "deletes": "Delete",
        "tips": "Tips",
        "details": "Details",
        "alarmDetails": "Alarm details",
        "alarmInfo": "Alarm situation",
        "alarmDevice": "Device Info",
        "delete_alarm": "Confirm to delete this alert?",
        "Cancel": "Cancel",
        "Confirm": "Confirm",
        "Close": "Close",
        "processed": "Handle",
        "untreated": "Unhandle",
        "allAlarm": "Total",
        "alarmStatus": "Total number of alarm events",
        "warningTitle": "Number of alarms in recent 7 days",
        "faultTitle": "Number of faults in recent 7 days",
        "alarmNum": "Number of alarms",
        "faultNum": "Number of faults",
        "all": "All",
        "warning": "Warning",
        "error": "Error",
        "fault": "Fault",
        "offline": "Offline",
        "inverter": "Inverter",
        "monitor": "Env-monitor",
        "smart_meters": "Smart meter",
        "combining_manifolds": "Combining manifolds",
        "Camera": "Camera",
        "Battery": "Battery",
        "Charger": "Charger",
        "storage": "Energy Storage Controller",
        "Prevent_arcing_island": "Anti-islanding",
        "Microinverter": "Microinverter",
        "Occurrence_time": "Occur time",
        "endtime": "End Time",
        "Device_Name": "Device name",
        "Device_PN": "PN",
        "Plant": "Plant",
        "Alarm_Code": "Alarm Code",
        "Alarm_Describe": "Description",
        "Device_SN": "SN",
        "device_alias": "Device Alias",
        "device_address": "Device address",
        "User": "User",
        "Status": "Status",
        "Operation": "Operation",
        "Delete_selected": "Delete Selected",
        "deleted_successfully": "The alarm is deleted successfully.",
        "Alarm_Msg": "New Message",
        "Intro_Msg": "Novice guidance",
        "Alarm_Read": "You have read all alarm notifications",
        "Alarm_data": "There is no latest news for the time being",
        "Alarm_Message": "Your",
        "Alarm_Message1": "Device appears",
        "curSelected": "Currently selected",
        "_Data": "Data",
        "more": "More",
        "ruleManage": "Alarm filtering rule management",
        "ruleNew": "New rule",
        "ruleName": "Rule name",
        "timeSlot": "Time slot",
        "deviceType": "Type",
        "deviceFilter": "Device filter",
        "alrmType": "Filter alarm type",
        "alrmDes": "Filter description",
        "filterHistory": "Filter history",
        "clearHistory": "Clear history",
        "view": "view",
        "back": "Back",
        "exportArchive": "Export archived alarm",
        "archiveRecord": "Archive record",
        "archiveTip": "The list includes all unprocessed alarms and processed records within 7 days"
    },
    "datalogger": {
        "activeStatus": "Active state",
        "Active": "Active",
        "notActive": "NotActive",
        "timeZone": "Timezone",
        "please_title": "Please enter 'YES' to confirm factory reset",
        "frequency": "Collection frequency",
        "heartbeat": "Heartbeat",
        "warehousing_time": "Storage time",
        "start_address": "Polling start address",
        "deadline_address": "Polling deadline address",
        "title_usr": "This datalogger has no affiliated user",
        "datalogger_log": "Log",
        "min_addr": "Minimum address",
        "max_addr": "Maximum address",
        "transmission": "Pure transparent identification",
        "transparent_set": "Pure transparent protocol set",
        "devcode": "Devcode",
        "domain_name": "Online domain name",
        "transmission1": "Local collection mode",
        "transmission2": "Pure transparent mode",
        "noDate": "Please select a date within 3 days",
        "paramSetting": "Parameter settings",
        "paramName": "Parameter name",
        "paramPar": "Parameter number",
        "paramVal": "The value of the parameter",
        "dataloggerView": "Datalogger details",
        "describe": "Description",
        "field_name": "Field name",
        "checkVal": "Numeric value",
        "resetTitle1": "Are you sure you want to reset the datalogger? (1: make it sign up again, 2: clear subordinate devices, 3: delete all data under the datalogger)",
        "unbingTitle": "Are you sure you want to unbind the datalogger? (1: Unbind the dealer administrator; 2: Rebind, please log in to the corresponding dealer administrator to add the datalogger)）",
        "getTitle": "Parameter acquisition",
        "postTitle": "Parameter Settings",
        "debugeTitle": "Setting up debugging",
        "getName": "Parameter acquisition (decimal)",
        "postName": "Parameter number (decimal)",
        "debugeName": "Command",
        "getVal": "Current value",
        "postVal": "Setting value",
        "debugeVal": "Result",
        "debugeAddr": "Device address",
        "getSucc": "Obtained successfully",
        "postSucc": "Set successfully",
        "debugeSucc": "Successfully issued",
        "copyVal": "Copy value",
        "huoqu": "Get",
        "shezhi": "Settings",
        "xiafa": "Issue command",
        "copy": "Copy succeeded",
        "flowCard": "No valid card found",
        "province": "Province/State",
        "city": "City",
        "county": "County/District",
        "country": "Country",
        "Flowcard_status": "Flow card status",
        "GPRS_traffic": "GPRS traffic",
        "upBatchDataloggerTip": "Note: batch upgrade is to upgrade the same datalogger firmware for multiple datalogger. If you don't know the firmware suitable for the datalogger, please choose carefully!",
        "upSuccessDatalogger": "Successfully upgraded datalogger",
        "upFailDatalogger": "Failed upgraded datalogger",
        "Datalogger_Status": "Status",
        "com_method": "Communication Method",
        "Datalogger_PN": "PN",
        "Datalogger_List": "Datalogger List",
        "Datalogger_Name": "Name",
        "Ple_PN": "Please enter the PN number of the Datalogger",
        "Ple_Alias": "Please enter the name of the Datalogger",
        "Datalogger_type": "Type",
        "Datalogger_model": "Model",
        "Datalogger_method": "Communication Type",
        "Status": "Status",
        "usr_belong": "User",
        "administrator": "Administrator",
        "Communication_balance": "Communication Balance",
        "load": "Load number",
        "Firmware_Version": "FMW VER",
        "signal": "Signal",
        "Operation": "Operation",
        "edit": "Edit",
        "reboot": "Restart",
        "unbind": "Unbind",
        "more": "More",
        "resetData": "Reset Data",
        "unbindUsr": "Unbinding the Owner",
        "debug": "Debug",
        "upgrade": "Upgrade",
        "delete": "Delete",
        "deleteTitle": "Delete datalogger",
        "reset": "Reset",
        "resetCode": "Please enter YES to confirm",
        "modify_datalog": "Datalogger info edit",
        "cancel": "Cancel",
        "confirm": "Confirm",
        "datalogger_debug": "Datalogger Debug",
        "communication_address": "Communication Address:",
        "Instruction": "Instruction:",
        "such_as": "Type in your command,like:AA BB CC DD EE FF",
        "return_content": "Return Content:",
        "send": "Send",
        "check": "Check",
        "InstructionType": "Instruction Format",
        "endMarker": "End Marker",
        "noMarker": "No End Marker",
        "noCheck": "No Check",
        "InstructionIssue": "Issue Instruction",
        "Insufficient": "Insufficient Times",
        "clear_data": "Clear Data",
        "device_upgrade": "Device firmware upgrade",
        "select_firmware": "Firmware:",
        "select_file": "Please Select the firmware file",
        "Upload": "Upload",
        "prompt_message": "Prompt Message",
        "confirm_deldte": "After the datalogger is deleted, you have no right to manage all data related to the Datalogger?",
        "Normal": "Normal",
        "Offline": "Offline",
        "Online": "Online",
        "Normal1": "Online",
        "Offline1": "Offline",
        "Allstate": "All",
        "modifySuc": "Successfully edit",
        "resetSuc": "Reset succeeded",
        "unbindSuc": "Unbind succeeded",
        "devaddrfail": "Communication addressField can not be empty",
        "Debugfail": "Debug failed, datalogger is offline!",
        "instruction_response": "Sending an instruction, waiting for a response...",
        "fileExceed": "File size exceeded",
        "uploadSuccess": "Upload success",
        "error1": "Only files in '.bin' and '.hex' formats can be uploaded！",
        "file_fist": "Please choose the firmware first",
        "updatefail": "Upgrade fail,datalogger is offline.",
        "update_suc": "Successfully update",
        "deleteSuc": "Successfully deleted",
        "debug_suc": "Successful debugging",
        "create": "Create",
        "addSuc": "Add datalogger successfully",
        "add": "Add Device",
        "addScq": "Add Datalogger",
        "batchAddScq": "Batch add Datalogger",
        "editDatalogger": "Edit Datalogger",
        "editDataloggerName": "Edit Datalogger",
        "resetDataloggerName": "Reset Datalogger",
        "unbindDataloggerName": "Unbind Datalogger",
        "resetDataloggerExplain": "This function is mainly used to facilitate manufacturers to clear cloud test data on device. After resetting the datalogger, the historical data of the device will be cleared. Once operated, the historical data of the device cannot be recovered. Please be careful!",
        "unbindDataloggerExplain": "This function is mainly used to facilitate the manufacturer to unbind the test account (owner) from the datalogger after the pre shipment test. Please operate this function carefully. Once the operation is completed, the customer needs to rebind the datalogger.",
        "rebootDataloggerName": "Restart the Datalogger",
        "rebootDataloggerSuc": "Datalogger restarted successfully",
        "fixOnRebootDataloggerName": "Confirm to restart the Datalogger:",
        "fixOnRebootDataloggerName1": "is it",
        "unbindTitle": "Please enter \"YES\" to confirm that you want to unbind the datalogger from the current terminal owner.",
        "resetTitle": "Please enter \"YES\" to confirm that you want to reset the datalogger.",
        "editSuc": "Edit datalogger successfully",
        "basic_info": "Basic info",
        "datalogger_pn": "PN:",
        "datalogger_name": "Name:",
        "nominalPower": "Nominal Power",
        "install_date": "Install Date",
        "installer": "Installer",
        "location_info": "Location info",
        "location_info1": "Geographic info",
        "district": "Administrative district",
        "address": "Datalogger Address",
        "dataloggerAddress": "Detailed address",
        "enterPosition": "Input Datalogger Address",
        "longi_lati": "longitude and latitude",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "currentAddress": "Current Address:",
        "timezone": "Timezone",
        "timezone1": "Timezone",
        "cp1": "Please select the install date",
        "cp2": "Please select a timezone",
        "cp3": "Please input the rated power",
        "cp4": "Please select a currency",
        "cp5": "Please input the device name",
        "cp6": "Please select a project",
        "cp7": "Please select latitude and longitude",
        "lonRange": "Numbers with a longitude range of -180 to 180",
        "latRange": "Numbers within the latitude range of -90 to 90",
        "cp9": "Please enter the current address",
        "cp10": "Please enter the project name",
        "income_info": "Income info",
        "currency": "Income Currency:",
        "buyProfit": "Buying Power Price:",
        "sellProfit": "Selling Power Price:",
        "unitProfit": "Using Power Price:",
        "generateProfit": "Generate Power Price:",
        "noNegative": "Please enter a non negative number",
        "buyProfitNew": "Buying Power Price",
        "sellProfitNew": "Selling Power Price",
        "generateProfitNew": "Generate Power Price",
        "add_datalogger": "Add Datalogger",
        "add_suc": "Add successfully",
        "basicInfo": "Basic info",
        "connectionInfo": "Connection info",
        "finishAdding": "Finish add",
        "addResults": "Add results",
        "addedSuccessfully": "Add successfully",
        "finish": "Finish",
        "continueAdding": "Continue add",
        "nowNoAdd": "Don't add now",
        "reAdd": "Re add",
        "editResults": "Edit Results",
        "resetResults": "Reset Results",
        "unbindResults": "Unbinding Results",
        "delResults": "Delete Results",
        "locationTip": "Warm tip: When positioning is inaccurate or positioning fails, you can enter it manually.",
        "upDatalogger": "Upgrade Datalogger",
        "type_code": "Data collector type code",
        "type_name": "Data collector type name",
        "new_type": "New data collector types added",
        "modification_type": "Modify data collector type",
        "delete_type": "Delete data collector type code",
        "prompt": "Preparing to delete data collector type codes",
        "prompt_codetip": "The data collector type code cannot be empty",
        "prompt_desctip": "The data collector type name cannot be empty",
        "input_prompt": "The data collector type code is a 1-digit letter",
        "success_prompt": "Successfully added code!",
        "multi_binding": "Batch Binding",
        "search_PN": "Enter PN",
        "empty_prompt": "No data,plaese enter and check the PN",
        "bingding_status": "Bingding Status",
        "unbound": "Unbound",
        "bound": "Bound",
        "protocol_code": "Protocol Code",
        "protocol_name": "Protocol Name",
        "bind": "Bind(Edit)",
        "bind_title": "Bind(Edit) Protocol",
        "batch_bind_title": "Batch Bindding(Edit)",
        "18digit": "18 Digit Bind",
        "18digit_title": "18 Digit Protocol Bind",
        "batch_protocol_binding": "Batch Protocol Binding",
        "upload_tips": "TIPS:xlsx,xls ONLY, the content of upload file, you can refer to the following figure",
        "disabledText": "Getting Data...",
        "disabledText1": "Select the Protocol",
        "upload_err": "'xlsx','xls' ONLY",
        "bounding_success": "Bounding success",
        "unbounding_success": "Unbounding Success",
        "unbound_tips": "Sure to unbind the protocol of the PN ",
        "unbound_tips1": " device?",
        "batch_change": "Batch Change",
        "batch_protocol_change": "Batch Protocol Change",
        "dataloggerTipName": "The datalogger has added by",
                "batch_edit_datalogger": "Batch Edit Datalogger",
                "upload_column_tips": "Friendly reminder: Column A is Datalogger PN, Column B is load count, Column C is baud rate, Column D is communication protocol, Column E is device manufacturer code, Column F is protocol manufacturer code, Column G is collection mode, Column H is min communication address, Column I is max communication address, no title needed, refer to the following image",
                "upload_csv_tips": "Friendly reminder: Upload file format must be csv, refer to the following image for file content",
                "click_enlarge": "Click to enlarge for details",
                        "collector_expire_time": "Collector Expiration Time",
                        "collection_cycle": "Collection Cycle",
                                "ascii_display": "ASCII Display:"
    },
    "map": {
        "sn": "SN:",
        "datalogger": "Name:",
        "address": "Device address:"
    },
    "rate": {
        "device_status": "Device Status",
        "datalogger_pn": "PN",
        "datalogger_pns": "PN:",
        "rate_list": "Rate List",
        "datalogger_name": "Name",
        "status": "Status",
        "Income_currency": "Income Currency",
        "Income_currencys": "Income Currency:",
        "generate_Rate": "Power Generation Rate",
        "generate_Rates": "Power Generation Rate:",
        "sell_Rate": "Power Selling Rate",
        "sell_Rates": "Power Selling Rate:",
        "buy_Rate": "Power Buying Rate",
        "buy_Rates": "Power Buying Rate:",
        "operating": "Operating",
        "edit": "Edit",
        "rate": "Rate",
        "cancel": "Cancel",
        "confirm": "Confirm",
        "modifySuc": "Successfully edit",
        "resetSuc": "Reset succeeded",
        "unbindSuc": "Unbind succeeded"
    },
    "auxiliary": {
        "auxiliaryFunction": "Auxiliary Function",
        "chartSupplement": "Real Chart",
        "realChart": "After opening, the chart displays real data."
    },
    "strategy": {
        "strategyUpgrade": "Upgrade Strategy List",
        "to": "Return",
        "UpgFirmware": "Local firmware management",
        "strategyIntro": "Overview of local upgrade process",
        "strategyInfor": "Upgrade Policy info",
        "strategyIntro1": "Description: This function module is only for Bluetooth local firmware upgrade. If you want to upgrade the firmware of devices such as Wi Fi or 4G, please move to [Device Management Device List Upgrade Operation]",
        "stategyStep2": "New FMW VER package",
        "stategyStep3": "Upload FMW VER package files in local firmware management",
        "stategyStep4": "APP Local Upgrade",
        "stategyStep5": "After the strategy takes effect, the APP receives an upgrade reminder and can upgrade locally",
        "stategyStep6": "Add strategy",
        "stategyStep7": "Add a new strategy in the upgrade strategy list, select Upgrade Firmware, set the upgrade method and take effect, associate the upgrade device, and generate the upgrade strategy",
        "stategyStep8": "View upgrade records",
        "stategyStep9": "View device upgrade status and results",
        "stategyDetail": "Name",
        "stategyDetail1": "Upgrade Firmware",
        "stategyDetail2": "Firmware size (KB)",
        "stategyDetail3": "Firmware Type",
        "stategyDetail4": "Baud rate",
        "stategyDetail5": "Method",
        "stategyDetail6": "Progress",
        "stategyDetail7": "Status",
        "stategyDetail8": "Start time",
        "stategyDetail9": "Expiry time",
        "upgradeList": "Upgrade Record List",
        "add_strategy": "Upgrade Strategy List",
        "strategy_time": "Effective time",
        "strategy_code": "Code",
        "strategy_name": "Name",
        "strategy_desc": "Description",
        "strategy_firmware": "Upgrade Firmware",
        "strategy_type": "Firmware Type",
        "strategy_baudrate": "Baud rate",
        "uprade_type": "Upgrade method",
        "uprade_name": "Force Upgrade",
        "uprade_name1": "Suggested upgrade",
        "uprade_result": "Result",
        "uprade_success": "Success",
        "uprade_fail": "Failed",
        "uprade_status": "Status",
        "uprade_time": "Time",
        "strategy_number": "Number",
        "strategy_status": "Strategy status",
        "start_time": "Start time",
        "end_time": "Expiry time",
        "edit": "Edit",
        "edit_strategy": "Edit Policy",
        "view": "View",
        "view_strategy": "View Policies",
        "cancel": "Cancel",
        "cancel_strategy": "Cancel Policy",
        "force_upgrade": "Force Upgrade",
        "suggested_upgrade": "Suggested upgrade",
        "In_effect": "In effect",
        "expired": "Expired",
        "Not_started": "Not started",
        "Not_upgraded": "Not upgraded",
        "Yes_started": "Upgraded",
        "policy_information": "Policy info",
        "associated_device": "Associated devices",
        "completion_strategy": "Completion Strategy",
        "upgrade_strategy_list": "Upgrade Strategy List",
        "Next": "Next",
        "TOP": "Previous",
        "confirm": "Confirm",
        "go_back": "Return",
        "strategy_detail": "Strategy Details",
        "strategy_search": "Policy Code/Policy Name",
        "strategy_upgrade_search": "SN/PN",
        "upgrade_remind": "Upgrade Reminder",
        "remind_desc": "Reminder Description",
        "default_desc": "Default Description",
        "default_desc1": "This device needs to be upgraded to a higher version before it can be used. Click on 'Force Upgrade' to upgrade. Please do not disconnect the Bluetooth connection and ensure smooth network operation during the upgrade.",
        "message_name": "Please enter a policy name",
        "message_desc": "Please enter a policy description",
        "message_firmware": "Please select firmware",
        "message_type": "Please select the firmware type",
        "message_baudrate": "Please select the baud rate",
        "message_timezone": "Please select a time zone",
        "message_time": "Please select a valid time",
        "message_uprade_type": "Please select the upgrade type",
        "delete_firmware": "Confirm to cancel this policy?",
        "delete_desc": "After cancellation, it will not be possible to recover, and the selected upgrade strategy will not be able to notify the device to upgrade",
        "Upgrade_tip": "Please select the device associated with the policy",
        "Upgrade_result": "Add Success",
        "start_date": "Effective date",
        "End_date": "Expiring date",
        "limits":     "Tip: in the uploaded file, column A should contain the data-logger PN; no header is required—see the example image below.",
        "mueas":      "Upgrade strategy",
        "upNum":      "Number of devices to upgrade",
        "deletCL":    "Delete strategy",
        "deletCL_TEST":"Are you sure you want to delete this strategy?",
        "ONE_UP":     "Single-device upgrade",
        "MO_UP":      "Bulk device upgrade",
        "MO_text": "Successfully imported",
"MO_tex1": "Duplicate",
"MO_tex3": "Not found",
"MO_tex2": "Organization",
"MO_tex4": "Firmware is used in active policy; cannot delete",
    },
    "cloudsUpgarde": {
        "cloudsFirmware": "Cloud Upgrade Firmware",
        "cloudsFirmwareList": "Cloud Upgrade List"
    },
    "upgradeManagement": {
        "create": "Create",
        "cancel": "Cancel",
        "confirm": "Confirm",
        "upload_firmware": "Upload",
        "edit_firmware": "Edit",
        "download_firmware": "Download",
        "delete_desc": "After deletion, it will not be possible to recover, and the upgrade strategy selected for this firmware will not be able to upgrade the device",
        "eidt_success": "Edit Success",
        "delete_success": "Cencel Success",
        "delete_success1": "Delete Success",
        "download_success": "Download success",
        "firmware_name": "Firmware Name",
        "Firmware_Version": "Version",
        "please_upgrade": "Please select the upload file",
        "upgrade_success": "Upload success",
        "please_input": "Please input",
        "Remarks": "Description",
        "Upload": "Upload",
        "download_firmware_prompt": "Confirm to download this firmware?",
        "upgrade_file_format": "Can only upload in. bin/. hex format, cannot exceed 1MB",
        "upgrade_file_format1": "Can only upload in. bin/. hex format",
        "upgrade_file_format2": "The file cannot exceed 1MB",
        "firmwareName_empty": "Firmware name cannot be empty",
        "firmwareVersion_empty": "Version number cannot be empty",
        "download_exception": "Download exception, please try again later",
        "upload_result": "Upload Result",
    },
    "project": {
        "choice": "Choice",
        "move": "Move",
        "manageProject": "Project",
        "project": "Project",
        "defaultProject": "Default project",
        "projectName": "Project Name",
        "projectRemark": "Project Remark",
        "projectId": "Project ID",
        "createProject": "Create project",
        "createResults": "Create Results",
        "createSuc": "Create Successfully",
        "editProject": "Edit project",
        "editResults": "Edit Results",
        "editSuc": "Edit Successfully",
        "delProject": "Delete project",
        "delResults": "Delete Results",
        "delSuc": "Delete Successfully",
        "upgradeResults": "Upgrade Results",
        "upgradeSuc": "Upgrade Successfully",
        "back": "Return",
        "placeholder": "Search device name/ SN /PN",
        "modifySuc": "Successfully",
        "upload": "Upload",
        "limit": "Picture size no more than 1M",
        "moveTo": "Move To",
        "moveSelect": "Move Selected",
        "deviceSn": "SN",
        "tipCard": "Card",
        "tipList": "List",
        "tipSearchSN": "By device",
        "tipSearchPN": "By Datalogger",
        "energyCurrent": "Current power",
        "energyDate": "Date energy",
        "energyMonth": "Month energy",
        "energyYear": "Year energy",
        "energyTotal": "Total energy"
    },
    "constant": {
        "renminbi": "RMB(￥)",
        "meiyuan": "USD($)",
        "ouyuan": "EUR(€)",
        "aoyuan": "AUD($A)",
        "yingbang": "GBP(£)",
        "gangbi": "HKD(HK$)",
        "ruidian": "SEK(Kr)",
        "lubi": "INR(₹)",
        "moxige": "Mexican Peso(Mex$)",
        "baxi": "Real(R$)",
        "Pakistani": "PKR (Rs)",
        "Rand": "ZAR(R)",
        "gmt0": "(GMT +00:00)  Coordinated Universal Time, Greenwich Mean Time,Dublin,Edinburgh,London,Lisbon,Casablanca, Monrovia,Reykjavik",
        "gmt_1": "(GMT +01:00) Amsterdam,Berlin,Bern,Rome,Stockholm,Vienna,Belgrade,Bratislava,Budapest,West Central Africa,Windhoek",
        "gmt_2": "(GMT +02:00) Amman,Beirut,Damascus,Harare,Pretoria,Helsinki,Kyiv,Riga,Sofia,Tallinn,Vilnius,Cairo,Minsk,Athens",
        "gmt_3": "(GMT +03:00) Baghdad,Kuwait,Riyadh,Moscow,St. Petersburg,Volgograd,Nairobi",
        "gmt_4": "(GMT +04:00) Abu Dhabi,Muscat,Yerevan,Baku,Tbilisi,Caucasus Standard Time,Port Louis",
        "gmt_5": "(GMT +05:00) Tashkent,Ekaterinburg,Islamabad,Karachi",
        "gmt_55": "(GMT +05:30) New Delhi",
        "gmt_6": "(GMT +06:00) Almaty,Novosibirsk,Astana,Dhaka,Novosibirsk",
        "gmt_65": "(GMT +06:30) Myanmar",
        "gmt_7": "(GMT +07:00) Krasnoyarsk,Bangkok,Hanoi,Jakarta",
        "gmt_8": "(GMT +08:00) Beijing,Chongqing,Hong Kong,Urumqi,Kuala Lumpur,Singapore,Perth,Taipei,Ulannbaatar,Irkutsk",
        "gmt_9": "(GMT +09:00) Osaka,Sapporo,Tokyo,Seoul,Yakutsk",
        "gmt_10": "(GMT +10:00) Brisbane,Vladivostok,Guam,Port Moresby,Hobart,Canberra,Melbourne,Sydney",
        "gmt_11": "(GMT +11:00) Magadan,Solomon Is.,New Caledonia",
        "gmt_12": "(GMT +12:00) Auckland, Wellington,Petropavlovsk-Kamchatka-Old,Fiji,Coordinated Universal Time+12",
        "gmt_13": "(GMT +13:00) Nuku'alofa",
        "gmt_neg_1": "(GMT-01: 00) Cape Verde Islands,Azores",
        "gmt_neg_2": "(GMT-02: 00) Mid-Atlantic, Coordinated Universal Time-02",
        "gmt_neg_3": "(GMT-03: 00) Brasilia,Buenos Aires,Greenland,Cayenne, Fortaleza,Montevideo",
        "gmt_neg_4": "(GMT-04: 00) Atlantic Time(Canada),Cuiaba,Georgetown,La Paz,Manaus,San Juan,Santiago,Asuncion",
        "gmt_neg_5": "(GMT-05: 00) Eastern Time(US &amp; Canada),Indiana(East),Bogota,Lima,Quito",
        "gmt_neg_6": "(GMT-06: 00) Central Time(US &amp; Canada),Guadalajara,Mexico City,Monterrey(old)",
        "gmt_neg_7": "(GMT-07: 00) Chihuahua,La Paz,Mazatlan(old),Mountain Time(US &amp; Canada),Arizona",
        "gmt_neg_8": "(GMT-08: 00) Pacific Time(US &amp; Canada),Baja California",
        "gmt_neg_9": "(GMT-09: 00) Alaska",
        "gmt_neg_10": "(GMT-10: 00) Hawaii",
        "gmt_neg_11": "(GMT-11: 00) Samoa,Coordinated Universal Time-11",
        "gmt_neg_12": "(GMT-12: 00) International Date Line West"
    },
    "basic": {
        "modifySuc": "Successfully edit",
        "Personal_info": "Personal info",
        "User_name": "Username:",
        "User_name1": "Username",
        "Nickname": "Nickname:",
        "Nickname1": "Nickname",
        "editNickname": "Edit nickname",
        "Ple_Nickname": "Please enter a nickname",
        "setNickname": "Setting nickname",
        "Email": "Email:",
        "Email1": "E-mail",
        "Email2": "E-mail:",
        "editEmail": "Edit email",
        "setEmail1": "Bind e-mail",
        "Mobile": "Phone",
        "Mobile1": "Phone",
        "editMobile": "Edit phone",
        "setMobile": "Bind phone",
        "Avatar": "User Image",
        "basic": "Personal info",
        "Save": "Save",
        "Select_all": "Restore select all",
        "Ple_phone": "Please enter the phone to be bound",
        "code": "Code:",
        "Ple_code": "Please input the verification code",
        "Obtain_code": "Obtain",
        "Bind_phone": "Bind phone",
        "After_bindingPh": "Password can be retrieved through the bound phone",
        "Untie_phone": "Untie phone",
        "Change_phone": "Change phone",
        "Bind_email": "Bind email",
        "Ple_email": "Please enter the email to be bound",
        "re_enter": "Re-obtain",
        "After_bindingEm": "Password can be retrieved through the bound email",
        "Unbind_email": "Unbind email",
        "Change_email": "Change email",
        "unbind_Ph": "Confirm to unbind your phone?",
        "unbinding_Ph": "After unbinding, you will not be able to use the phone to retrieve the password",
        "unbind_Em": "Confirm to unbind the email?",
        "unbinding_Em": "After unbinding, you will not be able to use the email to retrieve the password!",
        "mobile_code": "The verification code has been sent to your phone, please check it",
        "email_code": "The verification code has been sent to your email, please check it",
        "suc_ph": "Successfully bind phone",
        "suc_em": "Successfully bind email",
        "code_frequently": "Verification codes are sent frequently, please try again later",
        "personalCenter": "Account setting",
        "basicInfo": "Basic info",
        "accountSecurity": "Account Security",
        "backTo": "Return",
        "uploadAvatar": "Edit the avatar",
        "bindPhone": "Bind Phone",
        "bindEmail": "Bind Email",
        "changePwdTip": "A password with high security can make the account more secure. It is recommended that you change your password regularly and set a 6 ~ 32 digit password.",
        "bindPhoneTipBefore": "Bound phone:",
        "bindEmailTipBefore": "Bound email:",
        "bindPhoneTip": "Set up a phone to sign in and retrieve the password, and receive the notification sent by the system.",
        "bindEmailTip": "Set up a Email to sign in and retrieve the password, and receive the notification sent by the system.",
        "bindPhoneTipAfter": ", you can sign in and retrieve your password and receive the notification sent by the system.",
        "changeBtn": "Edit",
        "changePwd": "Edit Password",
        "changePwdSuc": "Password reset succeeded",
        "finished": "Finished",
        "retry": "Retry",
        "changeRes": "Change Result",
        "bindRes": "Bind Result",
        "noHanzi": "Password cannot contain Chinese",
        "Nickname_length_tip": "User nickname length is 2-32 bits"
    },
    "password": {
        "User_name": "Username:",
        "Password": "Edit Password",
        "Current_password": "Old Password:",
        "New_password": "New Password:",
        "Config_newpassword": "New password:",
        "PLCurrent_password": "Please input the old password",
        "PLNew_password": "Please input a new password",
        "PLConfig_newpassword": "Please confirm the new password",
        "editPwdSuc": "Password has been updated",
        "loginAgain": "The password has been edit successfully, please log in again",
        "Save": "Save"
    },
    "settingalarm": {
        "chosesstation": "Please select the power station",
        "addEmails": "Add Emails",
        "delete": "Delete E-mail successfully!",
        "deletes": "Deletes",
        "Email_List": "Email List",
        "Add_Mailbox": "Add Mailbox",
        "cancel": "Cancel",
        "Add": "Add",
        "Email_Setting": "Email setting",
        "Alarm_Type": "Alarm Type : ",
        "Warning": "Warning",
        "Error": "Error",
        "Fault": "Fault",
        "Receiving_Report": "Receiving Report",
        "Daily_Report": "Daily Report",
        "Monthly_Report": "Monthly Report",
        "Yearly_Report": "Yearly Report",
        "Receiving_Plant": "Receiving Plant: ",
        "E_Mail": "E-Mail: ",
        "Email": "Email",
        "Plant": "Plant",
        "Operation": "Operation",
        "Alarm_Typetabel": "Alarm Type",
        "Yes": "Yes",
        "No": "No",
        "Delete": "Delete",
        "suredelete": "Confirm to delete this email push?",
        "Delete_Mailbox": "Delete Mailbox",
        "Add_suc": "Add E-mail successfully",
        "create": "Create",
        "list": "NO.",
        "edit": "Edit"
    },
    "recharge": {
        "cancel": "cancel",
        "early_warning": "Flow card expiration warning",
        "orderno": "Order Number",
        "Recharge_tip4": "Recommend users who have registered for PayPal to use it",
        "recharge_type": "type",
        "Recharge_tip3": "Recommended for WeChat users who have already installed it",
        "Recharge1": "Recharge flow",
        "rechargeStatus": "Recharge status",
        "Recharge_tip5": "WeChat Pay",
        "openWx": "Please open mobile phone WeChat",
        "Hint_language": "Your device has a 2G device. At the request of the Ministry of Industry and Information Technology, 2G networks are gradually being phased out. It is recommended to purchase and replace 4G devices!",
        "rechMoney": "Recharge",
        "Recharge": "Recharge",
        "Recharge_tip": "Recharge Reminder",
        "Dead_Time": "Expiry time",
        "domestic": "domestic",
        "not_for_the_time_being": "cancel",
        "Hint_language1": "If you encounter any problems during the recharge process, please contact the after-sales service hotline at 0755-89993588",
        "rechDiscount": "Discount",
        "Search": "Search",
        "warning": "Early warning",
        "Recharge_tip2": "Please choose, for example: the same carrying capacity is 1; The same card type is 4G; Bulk recharge for mainland China data cards in the same region",
        "Recharge_tip1": "Only supports bulk recharge of cards of the same type",
        "rechScan": "Please open the mobile wechat to complete the payment",
        "rechTip": "Warm tips: 1. Only devices with the same card type (such as 4G domestic),the same number of loads and the same poverty alleviation platform status can be selected for the same order (the default display shows packages with the number of loads of 1 and not connected to the poverty alleviation platform);2. Recharging overdue cards and recharging from the 25th to the 5th of each month will be delayed by 1 ~ 14 days. Please wait patiently",
        "Traffic_status": "Traffic status",
        "Status": "Flow card status",
        "DataloggerPN": "PN：",
        "Recharge_money": "Recharge Value",
        "Overdue": "Overdue",
        "Cancel_recharge": "Cancel recharge",
        "Datalogger_List": "Datalog List",
        "Recharged": "Recharge Success",
        "Rcharge_Month": "Times（month）",
        "Service_Area": "Service Area",
        "Datalogger_PN": "PN",
        "rechargeDevice": "Datalogger :",
        "rechargeSucInfo": "You have paid successfully and the traffic will arrive within 24 hours.",
        "Confirm_recharge": "Confirm recharge",
        "scan": "Sweep the payment",
        "Paid": "Account Paid",
        "Time": "Recharge Time",
        "Unpaid": "Not Paying",
        "Operation": "operation",
        "Connecting_Devices": "with load number",
        "Recharge_reminder": "Recharge Reminder",
        "scanComplete": "Sweep to complete the payment",
        "unknown": "Unknown",
        "rechargeChannel": "Channel :",
        "Signal": "Signal",
        "Plant": "Plant name",
        "rechargeDiscount": "Discount :",
        "expired": "Expired",
        "load": "with load number",
        "Recharge_List": "Recharge List",
        "ccid": "CCID",
        "Order_Number": "Order Number",
        "Package_type": "Package type",
        "Recharge_record": "Recharge ecord",
        "DataloggerName": "Alias",
        "Recharging": "Recharging",
        "Recharge_Selected": "Recharge",
        "rechargeErr": "Please select the datalogger with the same number of loads",
        "rechargePrice": "Price :",
        "abroad": "abroad",
        "normal": "Normal",
        "previous": "Return",
        "CCID": "CCID",
        "CCID_time": "Expiration time of flow card",
        "serial_number": "No",
        "Activation_Time": "Activation time",
        "confirm": "Ok",
        "Recharge_status": "Recharge status",
        "Recharge_now": "Recharge Now",
        "Content_warning": "Dear user! It is found that the flow card of the device you are using is about to expire. If it is not recharged in time, the flow card will be cancelled by the operator and cannot continue to be used. In order not to affect your normal use, please recharge the equipment in early warning status in time!",
        "Recharge_fail": "Recharge Fail",
        "rechargePackage": "Package :",
        "rechargeSuc": "Payment successful",
        "pn": "PN",
        "Tips": "Tips",
        "Recharge_successful": "Recharge Success",
        'Recharge_tip6': 'There are cards that do not support recharging,Please contact the administrator',
        'area_domestic': 'Chinese Mainland',
        'area_abroad': 'international',
                'remedy_title': 'Recharge Order Remedy',
                'upload_tip': 'Friendly reminder: Upload file format is .txt'
    },
    "customize": {
        "switchSkin": "Switch Skin",
        "classic": "Pink",
        "purple": "Purple",
        "blue": "Blue",
        "orange": "Orange",
        "green": "Green"
    },
    "firmware": {
        "Firmware_limit_format": "Only .bin, .hex, and .s19 file formats are allowed",
        "Firmware_upload_fail": "Upload failed, please try again!",
        "Firmware_upload_failTip": "Upload Failed",
        "Firmware_limit1": "You can upload a maximum of",
        "Firmware_limit2": "files",
        "Firmware_limit3": "firmware",
        "Firmware_limitM": "Individual firmware file size cannot exceed",
        "Firmware_Name": "Firmware Name",
        "Firmware_desrc": "Firmware Description",
        "Size": "Size(KB)",
        "Upload_Time": "Upload Time",
        "Operation": "Operation",
        "Firmware_List": "Firmware",
        "Firmware_Lists": "Firmware List",
        "Add_Firmware": "Add Firmware",
        "deleteFirmware": "Delete",
        "Firmware_Version": "Version",
        "editFirmware": "Edit",
        "downloadFirmware": "Download",
        "tips": "Tips",
        "noRecord": "No record",
        "delete_firmware": "Confirm delete the firmware?",
        "del_firmware": "Delete Firmware",
        "firmware_upgrade": "Firmware Upgrade",
        "uploadTips": "Please upload the firmware file",
        "cancel": "Cancel",
        "confirm": "Confirm",
        "Upload_firmware": "Upload",
        "Firmware_description": "Firmware description:",
        "enter_content": "Please input the content",
        "Select_file": "Select file",
        "limit": "Only files '.bin'/'.hex',no more than 8M",
        "limit0": "Only files '.bin'/'.hex' '.s19',no more than 8M",
        "limit1": "Only files in \"xlsx\" format can be uploaded",
        "limit2": "Friendly prompt: Column A of the uploaded file is the Datalogger PN, and column B is the alias of the Datalogger. No title is required, as shown below.",
        "limit3": "Add successfully",
        "error1": "Only files in '.bin' and '.hex' and '.s19' formats can be uploaded！",
        "error2": " Please press LFU button",
        "deleteSuc": "Successfully deleted",
        "UploadTitle": "Please upload batch files",
        "Upload": "Upload",
        "Upload1": "Upload files",
        "upgrade_quit1": "The upgrade is abnormal and has been quit!",
        "upgrade_quit2": "Upgrade failed, please try again later!",
        "upgrade_quit3": "update successed",
        "upgrade_quit4": "Upgrade was manually cancelled",
        "upgrade_quit5": "Not in the upgrade",
        "upgrade_quit6": "Upgrade canceled",
        "upgrade_quit7": "Upgrade failed",
        "upgrade_quit8": "Upgrade exception",
        "upgrading": "upgrading",
        "upgrading1": "Upgrading connection, please wait",
        "updateCompleted": "Update completed",
        "CancelUpgradeSuc": "Cancel the upgrade successfully",
        "FailedCancelUpgrade": "Failed to cancel upgrade",
        "CancelUpgradeSuc11": "Cancel upgrade successfully, please wait for the datalogger to connect to the cloud before upgrading",
        "upgrade_wait": "Preparing for upgrade, please wait 1–2 minutes",
        "upgrade_wait1": "Upgrade preparation complete. Please wait until the datalogger comes online, then restart the upgrade task",
        "colOffline": "Datalogger is offline",
		"colUpgrading": "Already upgrading",
        "UpgradeStarting": "Upgrade starting, please wait...",
		"upgradeSq_fail": "Datalogger upgrade failed, please try again later!",

    },
    "browse": {
        "usr": "Sub-account",
        "email": "Email",
        "mobile": "Phone",
        "gts": "Sign up date",
        "desc": "Description",
        "enableStatus": "Enable Status",
        "Enable": "Enable",
        "Disable": "Disable",
        "addBrowse": "Add Sub Account",
        "pleaseUsr": "Please enter a sub account",
        "accountInfo": "Account info",
        "username": "Username",
        "password": "Password",
        "newPassword": "NewPassword",
        "confirmPassword": "Confirm Password",
        "usrInfo": "User info",
        "device": "Project Selection",
        "pleaseDevice": "Select project",
        "pleaseDevice_title": "Please select a project",
        "pleaseStatus": "Select Status",
        "addSuccess": "Successfully added sub account",
        "editSuccess": "Successfully edited sub account",
        "editBrowse": "Edit Sub Account",
        "deleteSuccess": "Successfully deleted",
        "deleteBrowse": "Delete",
        "delete_browse": "Confirm to delete the sub account?",
        "please_browsepwd": "Please check the new password and confirm the password input requirements"
    },
    "retrieve": {
        "Retrieve_password": "Retrieve Password",
        "Retrieve_passwordPhone": "Password retrieved by phone",
        "Retrieve_passwordEmail": "Retrieve password by email",
        "passwordEmail": "Unbound mailbox",
        "passwordEmail1": "Mailbox mismatch",
        "passwordPhone": "Phone is not bound",
        "passwordPhone1": "Phone does not match",
        "login": "Sign in",
        "signup": "Sign Up",
        "Enter_account": "Enter Account",
        "Verify_identidy": "Verify Identidy",
        "reset_Password": "Reset Password",
        "finish": "Finish",
        "account_password": "Please input the account you need to retrieve your password",
        "username": "Username",
        "Verification_code": "Verification Code",
        "phone_number": "Phone",
        "new_password": "New Password",
        "Con_password": "Confirm Password",
        "enter_name": "Please input username",
        "enter_code": "Please input the verification code",
        "Change_one": "Change One",
        "confirm": "Confirm",
        "bound_mobile": "Please input the bound phone",
        "Email_verification": "Email verification",
        "Obtain_code": "Obtain",
        "code_1minute": "The verification code has been sent to your phone and the input is valid within 1 minute.",
        "Email": "E-mail",
        "bound_email": "Please input the bound E-mail",
        "Phone_verification": "Phone verification",
        "code_5minutes": "The verification code has been sent to your email and the entry is valid within 5 minutes.",
        "New_password": "New login password",
        "Confirm_password": "Confirm new password",
        "Reset_successfully": "Reset successful,Please remember your password",
        "re-register": "Re-register",
        "Incorrect_code": "Incorrect verification code",
        "email_first": "Please fill in the email first",
        "mobile_first": "Please fill in the phone first",
        "Reset_passwordSuc": "Reset password successfully",
        "Get_codeSucc": "Get the Obtain successfully",
        "Getting_progress": "Getting in progress,Please wait.",
        "Newloginpassword": "New sign in password",
        "Confirmloginpassword": "Confirm the new login password",
        "step1": "Step 1",
        "step2": "Step 2",
        "step3": "Step 3",
        "step4": "Step 4"
    },
    "errCode": {
        "0": "Normal, no error",
        "1": "fail",
        "2": "overtime",
        "3": "The system is abnormal. Please contact the administrator",
        "4": "An non verifying signature",
        "5": "Salt is wrong and is not used by rules",
        "6": "Parameter format error",
        "7": "Platform refusal",
        "8": "Non privileged operation",
        "9": "Lack of necessary parameters",
        "10": "Failed to authenticate, please sign in again",
        "11": "Unsupported operations",
        "12": "No record",
        "13": "Beyond the limit",
        "14": "Repeated operations",
        "15": "No manufacturer key",
        "16": "Password verification failure",
        "17": "Password format error",
        "18": "The phone has been bound",
        "19": "Telephone format error",
        "20": "Account format error",
        "21": "Account format error (2 <= Account digits < 32)",
        "22": "Company name format error",
        "23": "Manufacturer's code is invalid",
        "24": "repeat of Account",
        "25": "The account has been disable, please contact the administrator",
        "26": "The email has been bound",
        "27": "The account has been cancelled. Please contact the administrator",
        "256": "No record",
        "257": "No datalogger can be found",
        "258": "No device can be found",
        "259": "Invalid PN number, please check if the PN number is correct",
        "260": "No plant can be found",
        "261": "Unable to find the user",
        "262": "The device has been offline",
        "263": "The datalogger has been offline",
        "264": "No alarm for device",
        "265": "No environment detector can be found",
        "271": "No edit operation",
        "272": "Repeat binding",
        "273": "Does not support adding datalogger for other manufacturers",
        "276": "It does not support the power station owners who have mobile devices containing other manufacturers.",
        "288": "Can't find a camera",
        "352": "No firmware can be found",
        "353": "No role can be found",
        "368": "No agreement can be found",
        "369": "No user groupings can be found",
        "370": "No power station grouping can be found",
        "371": "No GPRS traffic recharge package can be found",
        "372": "No found recharge order",
        "384": "Verification code error",
        "385": "Can't find device_token",
        "386": "No device configuration info can be found",
        "387": "Can not find the type of the datalogger",
        "512": "Mismatch of SMS authentication code",
        "513": "The verification code has been timeout",
        "514": "Phone/Email mismatch",
        "515": "Phone/Email unbound",
        "516": "Name can not be the same name",
        "517": "There is also a number of datalogger under the user or power station",
        "518": "The user also has a subordinate user",
        "519": "Username already exists",
        "520": "Duplicate PN number",
        "521": "The receiver does not belong to the user",
        "522": "The number of datalogger has already existed",
        "523": "Only support the owner of the power station",
        "525": "Verification code has been sent, Please try again later",
        "528": "This role is already bound to a user and cannot be deleted",
        "768": "There is no optional field in the protocol",
        "772": "The datalogger has been bound",
        "1024": "Not the browsers' account",
        "1025": "Only support dealers",
        "1026": "Only support device manufacturers",
        "1027": "A superior user needs to be a distributor or device manufacturer",
        "1028": "Unsupported recharge method",
        "1029": "Duplicate datalogger number",
        "1030": "Invalid GPRS card",
        "1031": "The user is not created by this administrator",
        "1041": "Key has failed or could not be found",
        "1042": "Invalid CCID",
        "1792": "The datalogger must all belong to the distributor"
    },
    "controlDeviceErrCode": {
        "1": "Operation failed. Please check the device and try again!",
        "2": "Response timeout, please try again!",
        "3": "The system is abnormal. Please contact the administrator",
        "6": "Format error, please contact the administrator",
        "8": "Reject, please contact the administrator",
        "9": "Operation is not supported, please contact the administrator",
        "11": "No permission please contact the administrator",
        "263": "The datalogger is currently offline. Please try again after the device is online!"
    },
    "control":{
		"setting": "Issue",
        "TouSetting": "System Operating Mode",
        "touCharge": "Charge BAT Frist",
        "touPersonal": "Self Use",
        "touComplete": "Full-Grid",
        "touClipping": "Time of Use",
        "touOffgrid": "Off-Grid",
        "confirmModeSwitch": "Confirm Mode Switch?",
        "modeSwitch": "Switch Mode",
        "startTime": "Start Time",
        "endTime": "End Time",
        "paramValue": "Please Select Parameter Value",
        "Monday": "Monday",
        "Tuesday": "Tuesday",
        "Wednesday": "Wednesday",
        "Thursday": "Thursday",
        "Friday": "Friday",
        "Saturday": "Saturday",
        "Sunday": "Sunday",
        "syncSetDay": "Sync Issue to Daily",
        "time": "Time Period 1",
        "time1": "Time Period 2",
        "time2": "Time Period 3",
        "time3": "Time Period 4",
        "time4": "Time Period 5",
        "time5": "Time Period 6",
        "setFail": "Issue Failed",
        "readFail": "Read Failed",
        "charge": "Charge",
        "discharge": "Discharge",
        "reading": "Read Successfully",
        "reading_loading": "Reading...",
        "pvMode": "Grid Feed-in Mode",
        "screenshot": "Screenshot"
	},
    "CollectorCountByOMSOrder": {
        "1": "Operation failed",
        "7": "Platform refusal",
        "8": "Rejected, please contact the administrator",
        "12": "There is no valid datalogger PN number under the order, please confirm the Order NO",
        "23": "The manufacturer's code is invalid. Please contact the administrator",
        "259": "There are invalid dataloggers under this order. Please contact the administrator",
        "261": "Unable to find the assigned distributor, please contact the administrator",
        "772": "The order already has a datalogger bound. Please confirm that the datalogger in the order is not bound"
    },
    "message": {
        "uname_is_required": "Account cannot be empty",
        "id_is_required": "Grouping cannot be empty",
        "pwd_is_required": "Password cannot be empty",
        "confpwd_is_required": "Confirm password cannot be empty",
        "invitation_is_required": "The experience code is required",
        "pwdAgain": "Please input the password again",
        "pwdSame": "Old and new passwords can't be the same",
        "oldPass_wrong": "Old password is wrong, please re-input",
        "pwdNotsame": "Two input password inconsistencies",
        "email_is_required": "E-mail cannot be empty",
        "email_info": "Please input the correct email address within 64 digits",
        "mobile_is_required": "Phone cannot be empty",
        "pn_is_required": "PN cannot be empty",
        "PN_info": "The length of the PN number is 14 or 18 digits, with the first letter being a capital letter and containing only uppercase English and numbers",
        "nodata": "No Data",
        "length2_64": "The digits is 2 to 64",
        "length2_32": "The digits is 2 to 32",
        "length6_20": "Only 6-20 letters, numbers, underlines can only be input",
        "length6_32": "The digits is 6 to 32",
        "delete_plant": "Delete plant",
        "modify_plant": "Change plant",
        "Exporting_the_report": "Exporting the report",
        "cancel": "Cancel",
        "search": "Search",
        "Logging_off": "This account is cancellation and cannot be sign in",
        "country_is_required": "Please select a country or region",
    },
    "report": {
        "Export_report": "Export report",
        "Subscribe_report": "Subscribe Report",
        "all_reports": "Export all",
        "Report_type": "Report type:",
        "Daily_report": "Daily report",
        "Monthly_report": "Monthly report",
        "Yearly_Report": "Year report",
        "Total_report": "Total report",
        "customize": "Customize",
        "Report_date": "Report date:",
        "Report_date1": "Note: The range of export date cannot exceed 31 days",
        "select_date": "Please select date",
        "to": "To",
        "start_date": "Start date",
        "End_date": "End date",
        "cancel": "Cancel",
        "Export": "Export",
        "download": "Waiting for download, please wait",
        "Batch_export": "Batch export",
        "current": "Current",
        "no_deAlarm": "No device alarm occurred in the last month",
        "Export_alarm": "Export alarm"
    },
    "actionLog": {
        "index": "Index",
        "date": "Date",
        "user": "User",
        "acitonDesc": "Aciton Desc",
        "startTime": "Start Time",
        "endTime": "End Time",
        "userName": "User Name",
        'userNote': 'Enter user name',
        'uidNote': 'Please enter UID',
        'PNNote': 'Please enter PN',
        'actionNote': 'Interface action',
        'All': 'All'
    },
    "factory": {
        "name": "Manufacturer name",
        "code": "Manufacturer code",
        "time": "Generation time",
        "append": "Add manufacturer code",
        "amend": "Modify manufacturer code",
        "delete": "Delete manufacturer code",
        "delete_warn": "Are you sure to delete the manufacturer coding?",
        "input_tip": "The manufacturer code consists of 2-3 digits or letters",
        "error_tip": "Input error",
        "right_tip": "Input correctly",
        "editSuc": "Modification completed",
        "prompt_codeTip": "The manufacturer code cannot be empty",
        "prompt_nameTip": "The manufacturer name cannot be empty",
        "ID": "ID",
        "acount": "Acount",
        "usrName": "User Name",
        "acountType": "Acount Type",
        "isEnabled": "Is Enabled",
        "chooseIsEnabled": "Please choose whether to enable or not",
        "enabled": "Enabled",
        "disabled": "Disabled",
        "visibleDevcode": "Visible Devcode",
        "pwd": "password",
        "accountInfo": "Account Info",
        "comfirmPwd": "Comfirm Password",
        "factoryInfo": "Manufacturer Info",
        "devcode": "Devcode",
        "devcode_is_requeired": "Devcode is requeired",
        "confirmDelete": "Sure to delete the",
        "confirmDelete1": "Manufacturer?",
        "ecoin": "Ecoin"
    },
    "keyList": {
        "companyName": "Full name of the company",
        "version_number": "Version number",
        "client": "client",
        "domainName": "Full name of domain name",
        "contact_information": "contact information",
        "key": "key",
        "describe": "describe",
        "unseal": "Is it enabled",
        "platform": "platform",
        "companyNameTips": "Company name cannot be empty",
        "domainNameTips": "The full name of the domain name cannot be empty",
        "version_numberTips": "Version number cannot be empty",
        "contact_informationTips": "Contact information cannot be empty",
        "clientTips": "Platform cannot be empty",
        "keyTips": "Key cannot be empty",
        "keyTips2": "A key with a length of sixteen bytes",
        "describeTips": "Description cannot be empty",
        "unsealTips": "Whether to enable cannot be empty",
    },
    "protocol": {
        "pn": "PN",
        "postal_address": "postal address",
        "Protocol_encoding": "Protocol encoding",
        "date": "date",
        "Please_date": "Please select a date",
        "Protocol_instructions": "Protocol instructions",
        "Query_Results": "Query Results",
        "query": "query",
        "CRC_verification": "CRC verification",
        "Length_verification": "Length verification",
        "Data_index": "Data index",
        "raw_data": "raw data",
        "verification_results": "CRC verification results",
        "agreement": "agreement",
        "atypism": "atypism",
        "verification_result": "Length verification result",
        "Analysis_results": "Analysis results",
        "Please_results": "Please obtain the query results first",
    },
    "rawData": {
        "pn": "PN",
        "Equipment_number": "Equipment serial number",
        "Equipment_coding": "Equipment coding",
        "Device_address": "Device address",
        "date": "date",
        "Please_date": "Please select a date",
        "encrypted": "Is it encrypted",
        "Please_type": "Please select the encryption type",
        "yes": "yes",
        "no": "no",
        "raw_data": "raw data",
        "analysis": "analysis",
    },
    "collectionFrequencyUP": {
        "collect_fast": "Energy Flow Collection Acceleration",
        "collect_fast2": "Energy Flow Acceleration",
        "collect_fast_fail": "Acceleration failed, please retry",
        "collect_fasting": "Accelerating",
        "collect_fast_starting": "Acceleration starting",
        "collect_fast1": "Detailed Data Collection Acceleration",
        "collect_fast1ing": "Detail Acceleration in Progress",
        "paySecCon": "Payment Confirmation",
        "energyFetchPic": "Are you sure to recharge? The acceleration range for recharging is the parameters on the energy flow chart page, as shown in the following figure",
		"historyFetchPic": "Are you sure to recharge? The acceleration range for recharging is the parameters on the data details page, as shown in the following figure",
		"reRechargeTip1": "The current device has already purchased the energy flow acceleration service. Continuing to purchase will incur charges again. Do you want to continue?",
		"reRechargeTip": "The current device has already purchased the data details acceleration service. Continuing to purchase will incur charges again. Do you want to continue?",
		"continueRecharge": "Continue Recharge",
        "collect_fasting_title": "Real-time Parameters Not Stored",
        "collect_Order_Record": "Accelerated recharge record",
        "Collection_terms": "Collection frequency acceleration recharge terms",
        "Recharge_failed_next": "Sorry for the failed recharge, you can try paying again",
        "view_order": "View orders",
        "Once": "once",
        "every_interval": "The currently selected acceleration specification is: every interval",
        "Collect_terms2": "1、 Scope of application of the package",
        "Collect_terms3": "The display parameters included in the protocol used by the collector for your recharge (note: if you select the Energy Flow Graph page for accelerated recharge, the scope of the package is limited to the display parameter range of the Energy Flow Graph page; if you select the Historical Data page for accelerated recharge, the scope of the package is limited to the display parameter range of the Historical Data page)",
        "Collect_terms4": "2、 Not supporting protocol/device replacement",
        "have_read": "I have read it thoroughly",
        "Collect_terms5": "Changing protocols/devices does not participate in acceleration enjoyment",
        "Collect_terms6": "3、 Unsubscribe package",
        "Collect_terms": "Collect accelerated recharge terms",
        "View_Details": "View Details",
        "Recharge_result": "Recharge result",
        "Collect_terms7": "Unsubscribe and change not supported after payment",
        "Online_payment": "Online payment",
        "Collect_terms8": "4、 Package price",
        "Collect_terms9": "Our fees are calculated based on your parameter quantity, accelerated collection frequency, and load capacity, and the final price is determined accordingly; In addition to the above conditions, historical data also involves storage time",
        "acquisition_frequency": "Collection frequency",
        "Recharge_failed": "Recharge Fail",
        "Recharge_amount": "Recharge Value",
        "Scan_payment": "Scan code payment",
        "collect_recharge": "Collection Acceleration Recharge (Detailed Data Collection Acceleration)",
        "collect_recharge1": "Collection Acceleration Recharge (Energy Flow Acceleration)",
        "Collect_terms10": "5、 Traffic consumption",
        "Purchase_Terms7": "There are other questions",
        "Purchase_Terms8": "If you have any other questions, you can contact our online customer service for consultation, and we will provide you with detailed answers",
        "Collect_terms11": "Accelerating the collection frequency will exacerbate traffic consumption",
        "Purchase_Terms6": "Our fees are calculated based on your parameter quantity, accelerated collection frequency, and load capacity, and the final price is determined accordingly; In addition to the above conditions, historical data also involves storage time",
        "Purchase_Terms5": "Package Price ",
        "Purchase_Terms4": "Please look forward to our new version. The current version only supports collecting and upgrading all display parameters. We apologize for any inconvenience caused!",
        "Purchase_Terms3": "Can't I customize the collection frequency upgrade for some parameters",
        "Real_parameters": "Real-time data",
		"Purchase_Terms1": "Collection Acceleration Validity Period",
		"Purchase_Terms2": "The expiration time of the collection acceleration service will be automatically calculated based on the duration of the package you purchased. The specific expiration time is subject to the page display",
        "device_Info": "Device info",
        "Recharge_successful_next": "Congratulations on your successful recharge. We are about to upgrade your collection frequency, and you can follow your collection frequency changes from now on",
        "Purchase_Terms": "Purchase Terms",
        "gather": "collection",
        "Recharge_time": "Recharge Time",
        "Payment_method": "Payment Terms",
        "Type": "Recharge type",
        "Recharge_now": "Recharge Now",
        "History_Data": "historical data ",
        "Collect_terms1": "Collection frequency service acceleration service terms",
        "Package": "Acceleration Package",
        "PN_order": "PN/Order Number",
        "Order_No": "Order Number",
        "Recharge_successful": "Recharge Success",
        "noRecharg": "The collector does not support recharging",
        "noRecharg_min": "Your collection speed has reached its fastest!",
        "noRecharg_wifi": "The current version only supports Wi-Fi module data acquisition",
        "paypalTip": "The final payment amount is based on PayPal",
        "upPrice": "Price difference",
    },
    alarmNew: {
        'fileName': 'File Name',
        'fileSize': 'File Size',
        'fileStatus': 'File Status',
        'progress': 'Progress',
        'can': 'Downloadable',
        'no': 'Exporting',
        'history': 'Export History'
    },
    	shuoriExport:{
       "exportRecords": "Export Records",
       "export": "Export",
       "exportTask": "Export task has been created. Please download it later from Export Records.",
       "noDownload": "The file URL is invalid or unavailable for download. Please try again.",
       'data': 'Date',
	},
    	colUnBindRecord: {
    'UnBindRecord': 'Datalogger Unbinding Record',
    "unStatus": "Unbinding Status",
    "unScene": "Unbinding Scenario",
    "oldUser": "Original User",
    "newUser": "New User",
    "unCount": "Number of Unbindings",
    "pnBarCode": "PN Barcode",
    "devicePicture": "Device Photo",
    "ip": "Unbound IP",
    "unTime": "Unbinding Time"
	},
    	rosRecharge: {
		'electronicInvoicing': 'Electronic Invoicing',
		'issueEInvoice': 'Issue E-Invoice',
		'invoiceHistory': 'Invoice History',
		'rechargeDuration': 'Recharge Duration',
		'year': 'Year',
		'month': 'Month',
		'day': 'Day',
		'days': 'Days',
		'pendingPayment': 'Pending Payment',
		'paymentSuccess': 'Payment Successful',
		'paymentFailed': 'Payment Failed',
		'orderClosed': 'Order Closed',
		'serviceTerminated': 'Service Terminated',
		'unpaid': 'Unpaid',
		'paying': 'Paying',
		'paid': 'Paid',
		'refunded': 'Refunded',
		'cancelled': 'Cancelled',
		'rechargeSuccess': 'Recharge Successful',
		'rechargeFailed': 'Recharge Failed',
		'pleaseSelectDate': 'Please select date',
		'orderNo': 'Order No.',
		'batchInvoicing': 'Batch Invoicing',
		'rechargeType': 'Recharge Type',
		'trafficRecharge': 'Traffic Recharge',
		'collectRecharge': 'Collection Recharge',
		'rechargeStatus': 'Recharge Status',
		'invoice': 'Invoice',
		'invoiceStatus': 'Invoice Status',
		'invoiceTime': 'Invoice Time',
		'viewDetail': 'View Details',
		'invoicing': 'Invoicing',
		'invoiceSuccess': 'Invoice Success',
		'invoiceFailed': 'Invoice Failed',
		'issueElectronicInvoice': 'Issue E-Invoice',
		'invoiceType': 'Invoice Type',
		'generalInvoice': 'General Invoice',
		'specialInvoice': 'Special Invoice (VAT)',
		'headerType': 'Header Type',
		'companyHeader': 'Company Header',
		'personalHeader': 'Personal/Non-enterprise Header',
		'pleaseInputCompanyHeader': 'Please enter company header',
		'taxNumber': 'Tax Number',
		'pleaseInputTaxNumber': 'Please enter taxpayer identification number',
		'headerName': 'Header Name',
		'suggestPersonalName': 'Suggest entering personal name/store name',
		'invoiceContent': 'Invoice Content',
		'internetCommService': 'Internet Communication Service',
		'invoiceAmount': 'Invoice Amount',
		'yuan': 'CNY',
		'moreInfo': 'More Info',
		'remarkAddressEtc': 'Remarks, address, etc.',
		'companyAddress': 'Company Address',
		'pleaseInputCompanyAddress': 'Please enter company address',
		'companyPhone': 'Company Phone',
		'pleaseInputCompanyPhone': 'Please enter company phone',
		'openingBank': 'Opening Bank',
		'pleaseInputOpeningBank': 'Please enter opening bank',
		'bankAccount': 'Bank Account',
		'pleaseInputBankAccount': 'Please enter bank account',
		'remark': 'Remarks',
		'pleaseInputRemark': 'Please enter remarks',
		'email': 'Email',
		'pleaseInputEmail': 'Please enter email address',
		'cancel': 'Cancel',
		'submit': 'Submit',
		'invoiceResult': 'Invoice Result',
		'invoiceSubmitted': 'Invoice application submitted',
		'invoiceExpectedTip': 'The invoice is expected to be issued within 48 hours, please check',
		'viewInvoiceStatus': 'View Invoice Status',
		'pleaseInputHeaderName': 'Please enter header name',
		'pleaseInputValidEmail': 'Please enter a valid email address',
		'invoiceApplyFailed': 'Invoice application failed',
		'viewInvoice': 'View Invoice',
		'downloadPdf': 'Download PDF',
		'manualService': 'Manual Service',
		'invoiceSentToEmail': 'Invoice information has been sent to your email, please check',
		'pleaseWaitInvoicing': 'Please wait patiently for invoicing to complete',
		'pleaseContactManual': 'Please contact manual service for invoicing',
		'noPdfAvailable': 'No PDF file available for download',
		'serviceUnavailable': 'Customer service is currently unavailable',

	}
}
export default en;
